import { useContext } from 'react';
import { t } from '@lingui/macro';
import { UserContext } from '@lib/contexts/UserProvider';
import { Button, Props as ButtonProps } from '@components/ButtonV2';
import { useStartTrialPlanSubscriptionMutation } from '@gql/generated';
import { snackbarVar } from '@lib/apollo/policies';

type Props = ButtonProps & { children: React.ReactChild; onComplete?(): void };

export const StartTrialSubscriptionButton = ({
  children,
  ...otherProps
}: Props) => {
  const [_, { refetch }] = useContext(UserContext);
  const [
    startTrialPlanSubscription,
    { loading },
  ] = useStartTrialPlanSubscriptionMutation({
    onCompleted(resp) {
      if (resp?.startTrialPlanSubscription?.success) {
        // show snackbar
        snackbarVar({
          isSnackBarOpen: true,
          snackBarMessage: t`trial_2023.activate_trial_subscription.success_message`,
        });
        refetch({ onlyBaseProperties: true });
      } else {
        // show snackbar
        snackbarVar({
          isSnackBarOpen: true,
          snackBarMessage: t`trial_2023.activate_trial_subscription.failed_message`,
        });
      }
    },
  });

  return (
    <Button
      loading={loading}
      {...otherProps}
      onClick={() => startTrialPlanSubscription()}
    >
      {children}
    </Button>
  );
};
